const TIPOS = ["menu", "dialog", "listbox"];

function ativadorDe(el) {
  return el.querySelector(".v-btn") || el.querySelector("[tabindex]") || el;
}

function opcoes(binding) {
  const v = binding.value;
  if (typeof v === "string") return { tipo: v, rotulo: null };
  return { tipo: (v && v.tipo) || "menu", rotulo: (v && v.rotulo) || null };
}

function caixaAberta() {
  return document.querySelector(".v-menu__content--active");
}

function papeisDeMenu(caixa, rotulo) {
  caixa.setAttribute("role", "menu");
  if (rotulo) caixa.setAttribute("aria-label", rotulo);
  const lista = caixa.querySelector(".v-list");
  if (lista) lista.setAttribute("role", "none");
  const grupo = caixa.querySelector(".v-list-item-group");
  if (grupo) grupo.setAttribute("role", "none");
  caixa
    .querySelectorAll(".v-list-item:not(.v-list-item--disabled)")
    .forEach((item) => {
      if (!item.getAttribute("role")) item.setAttribute("role", "menuitem");
      item.removeAttribute("aria-selected");
    });
}

function sincronizar(el, binding) {
  const { tipo, rotulo } = opcoes(binding);
  if (!TIPOS.includes(tipo)) return;
  const ativador = ativadorDe(el);
  if (!ativador) return;

  ativador.setAttribute("aria-haspopup", tipo);
  const caixa = caixaAberta();
  const aberto = !!caixa && caixa.contains(document.activeElement)
    ? true
    : ativador.getAttribute("aria-expanded") === "true" || !!caixa;
  ativador.setAttribute("aria-expanded", String(!!aberto));

  if (aberto && caixa && tipo === "menu") papeisDeMenu(caixa, rotulo);
  if (aberto && caixa && tipo === "dialog" && rotulo) {
    caixa.setAttribute("role", "dialog");
    caixa.setAttribute("aria-label", rotulo);
  }
}

function agendar(el, binding) {
  window.clearTimeout(el.__dropdownTimer);
  el.__dropdownTimer = window.setTimeout(() => sincronizar(el, binding), 30);
}

export default {
  inserted(el, binding) {
    sincronizar(el, binding);
    el.__dropdownHandler = () => agendar(el, binding);
    el.addEventListener("click", el.__dropdownHandler, true);
    el.addEventListener("keyup", el.__dropdownHandler, true);
    el.__dropdownFora = (evento) => {
      if (!el.contains(evento.target)) agendar(el, binding);
    };
    document.addEventListener("click", el.__dropdownFora, true);
    document.addEventListener("keyup", el.__dropdownFora, true);
  },
  componentUpdated(el, binding) {
    sincronizar(el, binding);
  },
  unbind(el) {
    window.clearTimeout(el.__dropdownTimer);
    if (el.__dropdownHandler) {
      el.removeEventListener("click", el.__dropdownHandler, true);
      el.removeEventListener("keyup", el.__dropdownHandler, true);
    }
    if (el.__dropdownFora) {
      document.removeEventListener("click", el.__dropdownFora, true);
      document.removeEventListener("keyup", el.__dropdownFora, true);
    }
    delete el.__dropdownHandler;
    delete el.__dropdownFora;
    delete el.__dropdownTimer;
  },
};
